import { render, staticRenderFns } from "./MemberRequest.vue?vue&type=template&id=51be356a&scoped=true"
import script from "./MemberRequest.vue?vue&type=script&lang=js"
export * from "./MemberRequest.vue?vue&type=script&lang=js"
import style0 from "./MemberRequest.vue?vue&type=style&index=0&id=51be356a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51be356a",
  null
  
)

export default component.exports